import React, { Component } from 'react';
import SelectSpecialties from './components/SelectSpecialties/index';
import Select from 'react-select'
//import 'react-select/dist/react-select.css';
const options = [
  { value: 'admin', label: 'Администратор' },
  { value: 'hr', label: 'HR-Менеджер' }
];
function getNormilizePermission (value){
  for(var item of options){
    if(item.value == value){
      return item;
    }
  }
}

var CreateChangePanel = React.createClass({
  getInitialState: function(){
    return({
      open: this.props.change ? true : false,
      error: false,
      login: this.props.change ? this.props.user.login : '',
      pass: this.props.change ? this.props.user.pass : '',
      numberPhone: this.props.change ? this.props.user.numberPhone : '',
      specialties: this.props.change ? typeof this.props.user.specialties != 'undefined' ? this.props.user.specialties : [] : [],
      telegram: this.props.change ? this.props.user.telegram : '',
      permission: this.props.change && this.props.user.permission ? getNormilizePermission(this.props.user.permission) : ''
    });
  },
  handlerOpen: function(){
    this.setState({
      open: true
    });
  },
  handlerClose: function(){
    if(this.props.change){
      this.props.actionChangeOpen();
    }else{
      this.setState({
        open: false
      });
    }
  },
  handlerOnChage: function(element){
    this.setState({
      [element.target.name]: element.target.value,
      error: false
    })
  },
  handlerCreate: function(){
    var data = {
          loginCreate: this.state.login,
          passCreate : this.state.pass,
          login      : this.props.login,
          pass       : this.props.pass,
          numberPhone: this.state.numberPhone,
          specialties: this.state.specialties,
          telegram   : this.state.telegram,
          permission   : this.state.permission.value
        },
        THIS = this;

    if(!data.loginCreate.length || !data.passCreate.length){
      this.setState({
        error: true
      })
      return;
    }
    if(!this.state.permission){
      alert('Выберите пользователю права!');
      return;
    }

    if(this.props.change){
      data.id = this.props.user.id;
      console.log('datadatadatadata', data)
      io.socket.post("/api/changeUser", data, function (response){
        if(response.success){
          THIS.props.actionChangeOpen();
          THIS.props.actionReloadUsers(response.users)
        }else{
          THIS.setState({
            error: true
          })
        }
      });
    }else{
      io.socket.post("/api/createUser", data, function (response){
        if(response.success){
          THIS.setState({
            open: false,
            login: '',
            pass: '',
            error: false
          })
          THIS.props.actionReloadUsers(response.users)
        }else{
          THIS.setState({
            error: true
          })
        }
      });
    }
  },
  onCheckSelect: function(data){
    console.log('data', 'saveSpecialties', data)
    this.setState({specialties: data})
  },
  render: function(){
    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        width: state.selectProps.width,
        borderBottom: '1px dotted pink',
        color: state.selectProps.menuColor,
        padding: 20,
      }),
    
      control: (_, { selectProps: { width }}) => ({
        width: width
      }),
    
      singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
    
        return { ...provided, opacity, transition };
      }
    };
    if(this.state.open){
      return(
        <div className={!this.props.change ? this.state.error ? 'UserList error' : 'UserList' : this.state.error ? 'error' : ''}>
          <div className={!this.props.change ? "User" : ""} >
            <div className="CreatePanel">
              <input type="value" autoCapitalize="none" onChange={this.handlerOnChage} value={this.state.login} placeholder="Логин" name="login" />
              <input type="value" autoCapitalize="none" onChange={this.handlerOnChage} value={this.state.pass} placeholder="Пароль" name="pass" />
              <input type="value" autoCapitalize="none" onChange={this.handlerOnChage} value={this.state.numberPhone} placeholder="Номер телефона" name="numberPhone" />
              <input type="disable" autoCapitalize="none" onChange={this.handlerOnChage} value={this.state.telegram} placeholder="@username" name="telegram" />
              <Select className="SelectSpecialtiesOpen" styles={customStyles} placeholder="Выберите права..." style={{position: 'relative', width: '100%', border: 0}} value={this.state.permission} onChange={item => {this.handlerOnChage({target: {value: item, name: 'permission'}})}} options={options} />
              <SelectSpecialties listSpecialties={this.props.specialties} specialties={this.state.specialties} saveSpecialties={this.onCheckSelect} />
              <div className="SelectSpecialtiesOpen" onClick={this.handlerCreate}>{this.props.change ? 'Изменить пользователя' : 'Создать пользователя'}</div>
              <div className="SelectSpecialtiesOpen" onClick={this.handlerClose}>Закрыть</div>
            </div>
          </div>
        </div>
      );
    }else{
      return(
        <div className="CreatePanel">
          <div className="SelectSpecialtiesOpen" onClick={this.handlerOpen}>Создать нового пользователя</div>
        </div>
      );
    }

  }
});

export default CreateChangePanel;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/components/CreatePanel/index.jsx
 **/